// Example of SVG converted to js array, so it can be used with CIcon.
// the first argument is two last values of svg viewBox,
// the second argument is the SVG content stripped of SVG tags
export const user = ['16 16', `
  <g>
    <g>
    <path d="M4.58889 3.88889C4.58889 2.12688 6.01577 0.7 7.77778 0.7C9.53979 0.7 10.9667 2.12688 10.9667 3.88889C10.9667 5.6509 9.53979 7.07778 7.77778 7.07778C6.01577 7.07778 4.58889 5.6509 4.58889 3.88889ZM0.7 12.6389C0.7 12.2495 0.889523 11.8566 1.325 11.4546C1.76523 11.0483 2.4085 10.6818 3.17576 10.3745C4.71141 9.75927 6.56737 9.45 7.77778 9.45C8.98819 9.45 10.8441 9.75927 12.3798 10.3745C13.1471 10.6818 13.7903 11.0483 14.2306 11.4546C14.666 11.8566 14.8556 12.2495 14.8556 12.6389V14.8556H0.7V12.6389Z" stroke="var(--active-svg-stroke-color, #C2CFE0)" stroke-width="1.4"/>
    </g>
  </g>
`]
